import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export class CustomerResource extends BaseCamelCasedResource {
    pk() {
        return this.key || "";
    }
}
CustomerResource.urlRoot = legacyApiResourceUrl("CustomerIDSearch/SelectCustomer/FindV2");
//# sourceMappingURL=CustomerResource.js.map